import React from "react";

import Search from "components/basic/search/Search";
import { Button } from "primereact/button";
import { T } from "services/lang/LanguageService";

type TableHeaderProps = {
  search: string;
  setSearch: (value: string) => void;
  onCreateClick: () => void;
};

const TableHeader: React.FC<TableHeaderProps> = ({ search, setSearch, onCreateClick }) => (
  <div className="flex justify-content-between align-items-center">
    <div className="flex gap-2 align-items-center">
      <Button
        icon="pi pi-plus"
        label={T("action.create-rule")}
        onClick={onCreateClick}
        className="p-button-success"
      />
      <Search value={search} onChange={setSearch} />
    </div>
  </div>
);

export default TableHeader;
